import {ServiceBase} from '../../ServiceBase';
import {IServiceFactoryExtended} from '../../service-factory-extended.interface';
import {OpenBankingActionHandler} from "./handlers/open-banking.action-handler";
import {UploadDocumentsFromCashierActionHandler} from "./handlers/upload-documents-from-cashier.action-handler";
import {OpenDepositActionHandler} from "./handlers/open-deposit.action-handler";
import {OpenWithdrawActionHandler} from "./handlers/open-withdraw.action-handler";
import {OpenLinkActionHandler} from "./handlers/open-link.action-handler";
import {OpenChatActionHandler} from "./handlers/open-chat.action-handler";
import {OpenEmailActionHandler} from "./handlers/open-link-with-form-post.action-handler";
import {OpenControlCenterFullActionHandler} from "./handlers/open-control-center-full.action-handler";
import {OpenClientPageActionHandler} from "./handlers/open-client-page.action-handler";
import {LogoutActionHandler} from "./handlers/logout.action-handler";
import {OpenHelpCenterActionHandler} from "./handlers/open-help-center.action-handler";
import {LoginActionHandler} from "./handlers/login.action-handler";
import {RegistrationActionHandler} from "./handlers/registration.action-handler";
import {TransactionHistoryActionHandler} from "./handlers/transaction-history.action-handler";
import {OpenCashierActionHandler} from "./handlers/open-cashier.action-handler";
import {OpenChallengesActionHandler} from "./handlers/open-challenges.action-handler";
import {NavigateClientPageActionHandler} from "./handlers/navigate-client-page.action-handler";
import {OpenMyAccountActionHandler} from "./handlers/open-my-account.action-handler";
import {OpenRichActionHandler} from "./handlers/open-rich.action-handler";
import {OpenControlCenterMiniActionHandler} from "./handlers/open-control-center-mini.action-handler";
import {OpenCasinoGameActionHandler} from "./handlers/open-casino-game.action-handler";
import {OpenForgotYourPasswordActionHandler} from "./handlers/open-forgot-your-password.action-handler";
import {OpenCasinoFreeToPlayActionHandler} from "./handlers/open-casino-free-to-play.action-handler";
import {OpenOnlineHelpActionHandler} from "./handlers/open-online-help.action-handler";
import {AutologinActionHandler} from "./handlers/autologin.action-handler";
import {AppRedirectActionHandler} from "./handlers/app-redirect.action-handler";

export class CasinofiedActionHandlerService extends ServiceBase {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        const actions = services.messageBroker.channels.performAction.topics;

        actions.login.registerResolver(payload => {
            return new LoginActionHandler(this.services).handle(payload);
        });

        actions.register.registerResolver(payload => {
            return new RegistrationActionHandler(this.services).handle(payload);
        })

        actions.openBanking.registerResolver(payload => {
            return new OpenBankingActionHandler(this.services).handle(payload);
        });

        actions.uploadDocumentsFromCashier.registerResolver((payload) => {
            return new UploadDocumentsFromCashierActionHandler(this.services).handle(payload);
        });

        actions.deposit.registerResolver((payload) => {
            return new OpenDepositActionHandler(this.services).handle(payload);
        });

        actions.withdraw.registerResolver((payload) => {
            return new OpenWithdrawActionHandler(this.services).handle(payload);
        });

        actions.transactionHistory.registerResolver(payload => {
            return new TransactionHistoryActionHandler(this.services).handle(payload);
        });

        actions.openCashier.registerResolver(payload => {
            return new OpenCashierActionHandler(this.services).handle(payload);
        });

        actions.openMyAccount.registerResolver(payload => {
            return new OpenMyAccountActionHandler(this.services).handle(payload);
        });

        actions.openChallenges.registerResolver(payload => {
            return new OpenChallengesActionHandler(this.services).handle(payload);
        });

        actions.navigateClientPage.registerResolver(payload => {
            return new NavigateClientPageActionHandler(this.services).handle(payload);
        });

        actions.openLink.registerResolver(payload => {
            return new OpenLinkActionHandler(this.services).handle(payload);
        });

        actions.openChat.registerResolver(payload => {
            return new OpenChatActionHandler(this.services).handle(payload);
        });

        actions.openEmail.registerResolver(payload => {
            return new OpenEmailActionHandler(this.services).handle(payload);
        });

        actions.openOnlineHelp.registerResolver(payload => {
            return new OpenOnlineHelpActionHandler(this.services).handle(payload);
        });

        actions.openControlCenterFull.registerResolver(payload => {
            return new OpenControlCenterFullActionHandler(this.services).handle(payload);
        });

        actions.openControlCenterMini.registerResolver(payload => {
            return new OpenControlCenterMiniActionHandler(this.services).handle(payload);
        });

        actions.openClientPage.registerResolver(payload => {
            return new OpenClientPageActionHandler(this.services).handle(payload);
        });

        actions.logout.registerResolver(payload => {
            return new LogoutActionHandler(this.services).handle(payload);
        });

        actions.openHelp.registerResolver(payload => {
            return new OpenHelpCenterActionHandler(this.services).handle(payload);
        });

        actions.openRich.registerResolver(payload => {
            return new OpenRichActionHandler(this.services).handle(payload);
        });

        actions.openCasinoGame.registerResolver(payload => {
            return new OpenCasinoGameActionHandler(this.services).handle(payload);
        });

        actions.openForgotPassword.registerResolver(payload => {
            return new OpenForgotYourPasswordActionHandler(this.services).handle(payload);
        });

        actions.openCasinoFreeToPlay.registerResolver(payload => {
            return new OpenCasinoFreeToPlayActionHandler(this.services).handle(payload);
        });

        actions.autoLogin.registerResolver(payload => {
            return new AutologinActionHandler(this.services).handle(payload);
        });

        actions.appRedirect.registerResolver(payload => {
            return new AppRedirectActionHandler(this.services).handle(payload);
        });
    }
}
